import { EMBEDDED_CONTENT_TAG_NAMES } from './dom/content';
import { getComputedStyle } from './style/computedStyle';

/*
 * In Chrome (v78.0.3904.108) it's not possible to edit an empty inline element nested in a contenteditable.
 * In most cases, empty span are invisible and it's not a big deal, except when they are nested in a li.
 * This is why we remove them.
 */

/**
 * Empty all li containing only nested inline elements with empty leafs.
 * @param container
 */
export function cleanListItemElements(container: Element) {
  const document = container.ownerDocument;
  if (!document) {
    return;
  }
  container.querySelectorAll('li').forEach(li => {
    // If li contains any text cursor can be put in it.
    if (li.innerText !== '') {
      return;
    }
    // We definitely de not want to remove embedded content even if they are inline.
    if (li.querySelector(Array.from(EMBEDDED_CONTENT_TAG_NAMES).join()) !== null) {
      return;
    }
    // If we cannot find a single block element in the li we empty its content.
    if (containInlineElementsOnly(li)) {
      Array.from(li.children).forEach(child => child.remove());
    }
  });
}

function containInlineElementsOnly(element: Element) {
  const { children } = element;
  for (let i = 0; i < children.length; i++) {
    const child = children[i];
    const style = getComputedStyle(child, element);
    if (style === null || style.display !== 'inline' || !containInlineElementsOnly(child)) {
      return false;
    }
  }
  return true;
}
